import { useContext } from 'react';
import { SearchContext } from './SearchContext.js';

export const useSearch = () => useContext(SearchContext);
